// extracted by mini-css-extract-plugin
export default {"filtersBar":"_2wugS","filterList":"_218jr","filterButton":"_19ysh","selected":"_3zgIG","fetchingButton":"_3WabS","placeHolderShimmer":"zUkNg"};